<template>
	<div class="d-flex flex-column ga-6">


		<div class="text-h6 font-weight-bold w-100" no-gutters>
			Withdrawal Method
		</div>



		<div class="w-100" style="min-height: 75vh;">

			<RewardList v-if="!loadingPayoutOptionsAndTheirDenominations"></RewardList>


			<div v-if="loadingPayoutOptionsAndTheirDenominations" class="rewards-grid-container">
				<v-skeleton-loader v-for="n in 20" :key="n" :elevation="4" type="image"
					color="var(--v-skeleton-loader-color)">
				</v-skeleton-loader>
			</div>

		</div>


		<Pagination 
			:model-value="pageNumber"
			@update:model-value="(value) => pageNumber = value"
			:length="pageLength" 
			:total-visible="totalVisible"
		/>



	</div>
</template>



<script setup>

import { computed } from 'vue';
import RewardList from './Reward-List.vue';
import { PayoutStore } from '@/store/PayoutStore';
import Pagination from "@/components/Common/Pagination.vue";
import { usePagination } from "@/composables/usePagination";

const payoutStore = PayoutStore();
const loadingPayoutOptionsAndTheirDenominations = computed(() => payoutStore.loadingPayoutOptionsAndTheirDenominations);

// Use the pagination composable to handle pagination logic
const { pageNumber, pageLength, totalVisible } = usePagination({
	store: payoutStore,
	getTotalPages: (store) => store.PayoutOptionsAndTheirDenominationsPaging.totalPages,
	getCurrentPage: (store) => store.PayoutOptionsAndTheirDenominationsPaging.page,
	setPage: (store, page) => store.setPayoutOptionsPage(page),
	fetchData: async (store) => await store.getPayoutOptionsAndTheirDenominations()
});


</script>



<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;
</style>